import React from 'react';
import { ArrowRight, Zap } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden pt-16">
      {/* Geometric Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-full mb-8 shadow-sm">
          <Zap size={16} className="text-black" />
          <span className="text-sm font-medium text-gray-800">Premium Technology Solutions</span>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-black mb-6 tracking-tight">
          EXPERIENCE
          <br />
          <span className="relative inline-block mt-2">
            THE EDGE
            <div className="absolute -bottom-2 left-0 right-0 h-1 bg-black"></div>
          </span>
        </h1>

        {/* Subheading */}
        <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-12 leading-relaxed">
          Cutting-edge technology solutions for professional environments and modern homes. 
          Discover innovation that transforms your space.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            onClick={() => scrollToSection('products')}
            className="bg-black hover:bg-gray-800 text-white px-8 py-6 text-lg rounded-lg transition-all duration-300 hover:scale-105 shadow-lg group"
          >
            Explore Products
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
          </Button>
          <Button 
            onClick={() => scrollToSection('contact')}
            variant="outline"
            className="border-2 border-black text-black hover:bg-black hover:text-white px-8 py-6 text-lg rounded-lg transition-all duration-300 hover:scale-105"
          >
            Contact Us
          </Button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto mt-20 pt-12 border-t border-gray-300">
          <div>
            <div className="text-3xl md:text-4xl font-bold text-black mb-2">3</div>
            <div className="text-sm text-gray-600 uppercase tracking-wide">Product Lines</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-bold text-black mb-2">12+</div>
            <div className="text-sm text-gray-600 uppercase tracking-wide">Products</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-bold text-black mb-2">100%</div>
            <div className="text-sm text-gray-600 uppercase tracking-wide">Quality</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-black rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-black rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
